var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68799 5.3035C6.88777 5.48824 7 5.73877 7 6C7 6.26123 6.88777 6.51176 6.68799 6.6965L1.79343 11.2213C1.59491 11.4011 1.32763 11.5013 1.04967 11.5C0.771718 11.4987 0.505548 11.396 0.309002 11.2143C0.112456 11.0326 0.00141732 10.7866 1.3474e-05 10.5296C-0.00139037 10.2727 0.106955 10.0256 0.301505 9.84207L4.45757 6L0.301505 2.15793C0.106955 1.97441 -0.00139037 1.72732 1.3474e-05 1.47037C0.00141732 1.21341 0.112456 0.967353 0.309002 0.785657C0.505548 0.60396 0.771718 0.50131 1.04967 0.500012C1.32763 0.498715 1.59491 0.598874 1.79343 0.778726L6.68799 5.3035Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.1c70613e8417e64297abb694d11e2c11.svg";
export { ForwardRef as ReactComponent };